import EventFlyerContainer from './event_flyer_container';

const EventFlyer = EventFlyerContainer;
export default EventFlyer;
